export default "__VITE_ASSET__DlPHKVwp__"